import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";

import Loader from "../Common/Loader/Loader";
import BookingItem from "./BookingItem/BookingItem";
import CommonModal from "../Modal/CommonModal";
import CancelScheduleBookForm from "../CancelScheduleBookForm/CancelScheduleBookForm";
import ScheduleBookingForm from "../ScheduleBookingForm/ScheduleBookingForm";



import { closeHeaderModal } from "../../actions/siteadmin/modalActions";
import history from "../../history";
import messages from "../../locale/messages";
import { scheduleDateSplitUp } from "../../helpers/bookingHelper";


import { LinkPlusIcon } from "../Common/Assets/SVGIcon/CommonSvgIcon";
import noResultFound from "../../../public/Icons/darkNoResultsFound.svg";
import bt from '../../components/commonStyle.css'
import s from './UpcomingBooking.css';


const UpcomingBooking = ({ getAllBooking, intl: { formatMessage } }) => {
    const redirectSearch = () => {
        history.push('/category?type=all')
    }

    const dispatch = useDispatch()

    const closeCancelScheduleModal = () => {
        dispatch(closeHeaderModal('cancelScheduleBooking'))
    }
    const closeUpdateScheduleModal = () => {
        dispatch(closeHeaderModal('scheduleBookingForm'))
    }

    const scheduleBookingForm = useSelector(state => state?.adminModalStatus?.scheduleBookingForm)
    const cancelScheduleBooking = useSelector(state => state?.adminModalStatus?.cancelScheduleBooking)
    const scheduleFrom = useSelector(state => state?.adminModalStatus?.formData?.scheduleFrom)
    const id = useSelector(state => state?.adminModalStatus?.formData?.id)
    const scheduleId = useSelector(state => state?.adminModalStatus?.formData?.scheduleId)
    const currency = useSelector(state => state?.adminModalStatus?.formData?.currency)
    const userId = useSelector(state => state?.adminModalStatus?.formData?.userId)
    const isUserBooking = useSelector(state => state?.adminModalStatus?.formData?.isUserBooking)

    let formData = {
        bookingId: id,
        scheduleFrom,
        scheduleId,
        currentPage: 1,
        currency,
        userId,
        isUserBooking
    }

    let scheduleInitialValues = scheduleDateSplitUp(parseInt(scheduleFrom));

    return (
        <>
            <CommonModal
                title={scheduleBookingForm ? formatMessage(messages.updateSchedule) : formatMessage(messages.cancelJob)}
                onHide={scheduleBookingForm ? closeUpdateScheduleModal : closeCancelScheduleModal}
                modalStatus={scheduleBookingForm ? scheduleBookingForm : cancelScheduleBooking} >
                {scheduleBookingForm ? <ScheduleBookingForm initialValues={scheduleInitialValues} formData={formData} /> : <CancelScheduleBookForm formData={formData} />}
            </CommonModal>
            {getAllBooking?.results?.length > 0 &&
                <div className={s.bookingCardListContainer}>
                    {getAllBooking?.results?.map((item, index) => (
                        <BookingItem
                            key={index}
                            id={item?.id}
                            currency={item?.currency}
                            categoryImage={item?.categoryDetails?.bannerImage}
                            amount={item?.userPayableFare}
                            categoryName={item?.categoryDetails?.name}
                            startLocation={item?.startLocation}
                            endLocation={item?.endLocation}
                            pricingType={item?.pricingType}
                            bookingType={item?.bookingType}
                            scheduleFrom={item?.scheduleBooking?.scheduleFrom}
                            status={item?.status}
                            paymentStatus={item?.paymentStatus}
                            dateAndTime={item?.createdAt}
                            scheduleId={item?.scheduleBooking?.id}
                            userId={item?.userDetails?.userId}
                        />
                    ))}
                </div>
            }
            {getAllBooking?.results?.length === 0 && <div className={bt.noResultSection}>
                <img src={noResultFound} alt="No Result" />
                <p className={bt.noResultText}><FormattedMessage {...messages.noBookings} /></p>
                <div className={bt.commonLinkWithIconContainer}>
                    <div onClick={() => redirectSearch()} className={bt.commonLinkWithIcon}>
                        <LinkPlusIcon />
                        <FormattedMessage {...messages.createNewBooking} />
                    </div>
                </div>
            </div>
            }
        </>
    )
}


export default injectIntl(withStyles(bt, s)(UpcomingBooking));
